import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'female-al',
	landing: {
		ids: ['loader-f'],
		route: {
			path: '/f-al',
			name: 'female-funnel',
		},
	},
	funnel: {
		id: 'ob-female-funnel-al',
		route: {
			path: '/f-al/ob/:page*',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-al-survey',
		},
		slug: 'female-al',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-f-al',
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f', 'upsell-upgrade-f-al'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
